import type { DataGridColumn } from '../types';
import { getExportHeader, readExportValue, resolveExportColumns } from './value';

function formatForString(value: string | number | Date | null | undefined): string {
  if (value === null || value === undefined) return '';
  if (value instanceof Date) return value.toLocaleDateString('fr-FR');
  return String(value);
}

/** RFC 4180 escape — wrap in quotes and double any inner quote. */
function escape(raw: string): string {
  if (/[",\n\r]/.test(raw)) return `"${raw.replace(/"/g, '""')}"`;
  return raw;
}

/**
 * CSV export — RFC 4180 compliant with a UTF-8 BOM prefix so Excel opens
 * the file in the right encoding out of the box. Flat output: grouping
 * and subtotals are not serialized (CSV is by nature a flat format).
 */
export function buildCsv<T>(columns: DataGridColumn<T>[], rows: T[]): Blob {
  const exportCols = resolveExportColumns(columns);

  const headerLine = exportCols.map((col) => escape(getExportHeader(col))).join(',');
  const bodyLines = rows.map((row) =>
    exportCols.map((col) => escape(formatForString(readExportValue(col, row)))).join(',')
  );
  const csv = '\uFEFF' + [headerLine, ...bodyLines].join('\r\n');
  return new Blob([csv], { type: 'text/csv;charset=utf-8' });
}
